import { useMutation } from '@apollo/client'
import { useSelector } from 'react-redux'

import {
  BulkUpdateAccountsPrivacyDocument,
  LiteRetailerAccountsInfoDocument,
  LiteRetailerConnectedAccountsDropdownDocument,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'
import { isLiteRetailer as isLiteRetailerSelector } from 'store/currentUser/selectors'

atlas`#graphql
  mutation BulkUpdateAccountsPrivacy($input: BulkUpdateAccountsPrivacyInput!) {
    bulkUpdateAccountsPrivacy(input: $input) {
      accounts {
        id
        name
        privacy
      }
    }
  }
`

export const useUpdateAccountsPrivacy = () => {
  const isLiteRetailer = useSelector(isLiteRetailerSelector)
  const [mutate, { loading, error }] = useMutation(
    BulkUpdateAccountsPrivacyDocument,
    {
      client: atlasClient,
    },
  )

  return {
    updateAccountsPrivacy: (
      accounts: {
        accountId: string
        privacy: boolean
      }[],
    ) => {
      const retailerIds = accounts.map(({ accountId }) => accountId)
      return mutate({
        variables: {
          input: {
            accounts,
          },
        },
        refetchQueries: [
          ...(isLiteRetailer ? [LiteRetailerAccountsInfoDocument] : []),
          {
            query: LiteRetailerConnectedAccountsDropdownDocument,
            variables: { retailerIds },
          },
        ],
      })
    },
    loading,
    error,
  }
}
